import {
    getPatients,
    addPatient,
    editPatient,
    deletePatient,
    changeStatus
} from "./patients.action";

export {patientsReducer} from "./patients.reducer";
export {watchPatients} from "./patients.saga";

export const patientsActions = {
    /** Patients */
    getPatients,
    addPatient,
    editPatient,
    deletePatient,
    changeStatus
};
